import * as React from 'react'
import {translateCountryName} from "@ui-seeker/utils"

import {Box} from "@mui/material";
import {LabelCountry} from "@components";

export default function countryColumn() {
    return [{
        name: 'userCountry', label: 'Country',
        options: {
            display: 'excluded',
            customBodyRowRender: v => v.toLowerCase() !== 'all' ? translateCountryName(v) : 'ALL'
        }
    }, {
        name: 'userCountry', label: 'Country',
        options: {
            filter: false,
            customBodyRowRenderLite: value =>
                <Box display={'flex'} flexDirection={"column"} justifyContent={'center'} alignItems={'center'}>
                    {value.toLowerCase() !== 'all' ? <LabelCountry
                        country={value}
                        label={translateCountryName(value)}
                    /> : 'All'}
                </Box>
        }
    }]
}